// 客户
export const CUSTOMER = "customer";

// vip
export const VIP = "vip";
